<script>
export default {
  methods: {
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          // eslint-disable-next-line 
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    validatePhone(email) {
      return String(email)
        .toLowerCase()
        .match(
          // eslint-disable-next-line 
          /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
        );
    },
  },
};
</script>